import {mapActions, mapMutations, mapGetters} from 'vuex';

import {required, maxLength, minLength} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

export default {
  name: 'roles.create',
  mixins: [validationMixin],
  data() {
    return {
      payload: {
        translations: [],
        permissions: [],
      },
      currentTranslations: 0,
      validationErrors: {},
    }
  },
  components: {},
  validations: {
    payload: {
      permissions: {
        required
      },
      translations: {
        $each: {
          title: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(20)
          },
          description: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(60)
          }
        }
      }
    }
  },
  created() {
    this.fetchPermissions().then(()=>{
      this._applyData();
    })
  },
  mounted() {},
  computed: {
    ...mapGetters({
      permissions: 'permissions/permissions',
      isPermissionsLoading: 'permissions/isPermissionsLoading',
      isRoleCreating: 'roles/isRoleCreating',
    }),
    ...mapGetters([
      'languages',
    ]),
    permissionsErrors() {
      let error = [];
      if (!this.$v.payload.permissions.$dirty) {
        return error;
      }
      if (!this.$v.payload.permissions.required) {
        error.push(this.$t('validationRequired'));
      }
      return error;
    },
  },
  methods: {
    ...mapActions({
      fetchPermissions: 'permissions/PERMISSIONS_REQUEST_LIST_GET',
      createRole: 'roles/ROLES_REQUEST_CREATE',
    }),
    _applyData() {
      this.payload.translations = this.languages.map(langItem => {
        return {
          locale: langItem.translationKey,
          title: '',
          description: '',
        }
      });
    },
    translationsTitleErrors(index) {
      let error = [];
      if (!this.$v.payload.translations.$each[index].title.$dirty) {
        return error;
      }
      if (!this.$v.payload.translations.$each[index].title.required) {
        error.push(this.$t('validationRequired'));
      }
      if (!this.$v.payload.translations.$each[index].title.minLength) {
        error.push(this.$t('validationMin',{count: 1}));
      }
      if (!this.$v.payload.translations.$each[index].title.maxLength) {
        error.push(this.$t('validationMax',{count: 20}));
      }
      return error;
    },
    translationsDescriptionErrors(index) {
      let error = [];
      if (!this.$v.payload.translations.$each[index].description.$dirty) {
        return error;
      }
      if (!this.$v.payload.translations.$each[index].description.required) {
        error.push(this.$t('validationRequired'));
      }
      if (!this.$v.payload.translations.$each[index].description.minLength) {
        error.push(this.$t('validationMax',{count: 2}));
      }
      if (!this.$v.payload.translations.$each[index].description.maxLength) {
        error.push(this.$t('validationMax',{count: 60}));
      }
      return error;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        let payload = {
          permissions:  this.payload.permissions
        }
        this.payload.translations.forEach(item => {
          payload[item.locale] = {
            title: item.title,
            description: item.description,
          }
        });

        this.createRole(payload).then(() => {
          this.$toasted.success(this.$t('dataUpdated'));
          this.$router.push({name: 'roles.list'}).catch(()=> {console.log()})
        }).catch(error => {
          if (error.response.status === 422) {
            this.$toasted.error(error.response.data.message);
            this.validationErrors = error.response.data.errors
          }
        });
      }
    }
  }
}
